import { apiUrl } from "../config";

export const fetchFormBuilderData = async (id) => {
  try {
    const token = localStorage.getItem("token") || "";

    const response = await fetch(apiUrl+'/logic/getAllQuizLogicsWithSlides', {
    // const response = await fetch('https://eobkx7tofzghsbo.m.pipedream.net', {
      method: 'POST',
          headers: {
          'charset': 'utf-8', 'token': token, 'Content-Type': 'application/json'
          },
        body: JSON.stringify({
        // Whatever data you want to send in the request body
          quizId: id,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch form data: ${response.statusText}`);
    }
    const data = await response.json();
    
    // Validate required data structure
    if (!data.slides || !Array.isArray(data.slides)) {
      throw new Error('Invalid form data: slides array is required');
    }
    
    console.log('Fetched form data:', data);
    return data;
  } catch (error) {
    console.error('Error fetching form data:', error);
    throw error;
  }
};